// extracted by mini-css-extract-plugin
export default {"root":"_2r6Z5BEZcgcf3hpAa5JAag","text":"p2c4_rrrBUdn0bW5qzOj4"};